import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useGetProjectsQuery } from "../redux/api/projectsApi";
import { useGetBrandsQuery } from "../redux/api/brandsApi";
import {
  setCurrentProject,
  setProjects,
  setProjectsLoaded,
} from "../redux/project/projectSlice";
import {
  setBrands,
  setCurrentBrand,
  setBrandsReady,
} from "../redux/brand/brandSlice";
import { store } from "../redux/store";

const WorkspaceBootstrap = () => {
  const dispatch = useDispatch();
  const currentProject = useSelector((state) => state.project.currentProject);
  const projectsLoaded = useSelector((state) => state.project.loaded);
  const { isSuccess: projectsSuccess, data: projectsData } =
    useGetProjectsQuery();
  const { isSuccess: brandsSuccess, data: brandsData } = useGetBrandsQuery({
    page_size: 1000,
    sort_by: "create_date",
  });

  useEffect(() => {
    if (!projectsSuccess) {
      return;
    }

    const results = projectsData?.results ?? [];
    dispatch(setProjects(results));

    if (results.length > 0) {
      const storedHash = localStorage.getItem("currentProjectHash");
      const storedProject = storedHash
        ? results.find((project) => project.hash === storedHash)
        : null;
      const projectToSet = storedProject || results[0];
      const current = store.getState().project.currentProject;
      if (!current?.hash || current.hash !== projectToSet.hash) {
        dispatch(setCurrentProject(projectToSet));
      }
    } else {
      dispatch(setCurrentProject(null));
    }

    dispatch(setProjectsLoaded(true));
  }, [projectsSuccess, projectsData, dispatch]);

  useEffect(() => {
    if (!brandsSuccess || !projectsLoaded) {
      return;
    }

    if (!currentProject?.hash) {
      dispatch(setBrands([]));
      dispatch(setBrandsReady(true));
      return;
    }

    const allBrands = brandsData?.results ?? [];
    const projectBrands = allBrands.filter(
      (brand) => brand.project_hash === currentProject.hash,
    );
    dispatch(setBrands(projectBrands));

    const storedHash = localStorage.getItem("currentBrandHash");
    const currentHash = store.getState().brand.currentBrand?.hash || storedHash;
    const matchedBrand = currentHash
      ? projectBrands.find((brand) => brand.hash === currentHash)
      : null;

    if (matchedBrand) {
      dispatch(setCurrentBrand(matchedBrand));
    } else if (projectBrands.length > 0) {
      dispatch(setCurrentBrand(projectBrands[0]));
    } else {
      dispatch(setCurrentBrand(null));
    }

    dispatch(setBrandsReady(true));
  }, [
    brandsSuccess,
    brandsData,
    currentProject?.hash,
    projectsLoaded,
    dispatch,
  ]);

  return null;
};

export default WorkspaceBootstrap;
